import React from 'react';
import { Container, Row, Col,Button,Modal, ModalHeader,ModalBody,ModalFooter,Form,FormGroup,Label,Input} from 'reactstrap';
import './ListViewBranch.css';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import {  ui,libs,framework  } from 'saffroncodejs';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faFax, faPhone, faMapPin } from '@fortawesome/fontawesome-free-solid';
import Config from '../../Core/Config.js';
import { Link } from "react-router-dom";
var PageManager = framework.PageManager;


class ListViewBranch extends React.Component {
  constructor(props) {
    super(props);
    this.toggle3 = this.toggle3.bind(this);
    this.toggle4 = this.toggle4.bind(this);
    this.toggle5 = this.toggle5.bind(this);
    this.setcityHolder=this.setcityHolder.bind(this);
    this.state = {
      isLoading: true,
      currentLatitude: '',
      currentLongitude: '',
      data: [{ "Code": 99, "Kind": 201, "PersonKind": 47, "Active": true, "State": 1, "Name": "اجرايي مرکز", "Tel": "22258046", "Mobile": null, "Fax": "22923846", "CodePosti": "1911933183", "Email": "Novin99@NovinInsurance.com", "Address": "تهران - بلوار ميرداماد - ميدان مادر (محسني) - خيابان بهروز - ساختمان شماره 11", "WebSiteAddress": null, "BeginDate": "1384/12/15", "EndDate": null, "Degree": 1, "City": "تهران", "Jens": null, "Economic": null, "CompanyCode": null, "SabtNo": null, "DisplayOrder": 1, "Longitude": 51.4427787065506, "Latitude": 35.759328852984716, "Distance": null }],
      cityHolder:'',
      modal: false,
      modal2: false,
      modal5: false,
      isOpen: false,
      nestedModal: false,
      closeAll: false
    };
    this.viewMap=this.viewMap.bind(this);
    this.state.data = [];
    this.getMyLocation = this.getMyLocation.bind(this);
    
  }
  componentDidMount() {
    
      this.getMyLocation();
      
  }
  getMyLocation() {
    navigator.geolocation.getCurrentPosition(function(position) {
        this.setState({
          currentLatitude: position.coords.latitude,

          currentLongitude: position.coords.longitude
        });
        
        this.loadDetail();
      }.bind(this));
    

  }
  loadDetail() {
     Axios.get(BimeManager.etelaatshoab + "/Get/?" + BimeManager.makeGetBody({ kind: null, KindArray: '201', currentLatitude: this.state.currentLatitude, currentLongitude: this.state.currentLongitude }))
    
      .then((result) => {
        
        this.setState({ data: result.data, isLoading: false })
        console.log("result.data : ", this.state.data);
      })
      .catch((error) => {
          if(error.includes(400)){
            this.setState({
              modal2: !this.state.modal2
          });
          }
          else alert(error) })
  }
  toggle3() {
    this.setState({
        modal: !this.state.modal
    });
}
toggle4(){
  this.setState({
    modal2: !this.state.modal2
});
}
setcityHolder(event){
  this.setState({
    cityHolder:event.target.value
  })
}
toggle5(){
  this.setState({
    modal5: !this.state.modal5
});
}
viewMap(lat,lon, name){
  if(lat!==0&& lon!==0){
    PageManager.changePage(Config.p_viewonmap, [lat,lon,name])
  }
 else{
  this.setState({
    modal5: true
});
 }
}
  render() {
    return (
      <div>
         {/* Modal */}
 
      <Modal isOpen={this.state.modal2} toggle={this.toggle4}  className="alert_phishnahadha">
      <ModalHeader toggle={this.toggle4}></ModalHeader>
      <ModalBody>
            لطفا دوباره تلاش بفرمایید
          </ModalBody>
      <ModalFooter>
        <Button  color="primary" onClick={this.toggle4}>بستن </Button>
      </ModalFooter>
    </Modal>
    {/* Modal */}
     {/* Modal */}
 
     <Modal isOpen={this.state.modal5} toggle={this.toggle5}  className="alert_phishnahadha">
          <ModalHeader toggle={this.toggle5}></ModalHeader>
          <ModalBody>
          برای این نمایندگی آدرسی روی نقشه ثبت نشده است            
          </ModalBody>
          <ModalFooter>
            <Button  color="primary" onClick={this.toggle5}>بستن </Button>
          </ModalFooter>
        </Modal>
        {/* Modal */}
        <Row>
          <Col sm="12" className="alignRight title">
            <h4>اطلاعات شعب</h4>
          </Col>
        </Row>
        {!this.state.isLoading ? (

          <Container>
           {/* Modal */}
 
        <Modal isOpen={this.state.modal} toggle={this.toggle3}  className="alert_phishnahadha">
          <ModalHeader toggle={this.toggle3}></ModalHeader>
          <ModalBody>
                <Form >
                  <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                    <Label for="exampleNumber " sm={3} >نام شهر</Label>
                    <Col sm={9}>
                      <Input type="text"  value={libs.StringFunctions.KaafYe(this.state.cityHolder)} onChange={this.setcityHolder} FullName="Email" id="exampleEmail" placeholder="" />
                    </Col>
                  </FormGroup>
                </Form>

              </ModalBody>
          <ModalFooter>
            <Button  color="primary" onClick={this.toggle3}>بستن </Button>
          </ModalFooter>
        </Modal>
        {/* Modal */}
        <div class="buttons">
          <Button className="btn btn-secondary" onClick={this.toggle3}>فیلتر</Button>
        </div>
       
            {
              //alert('bill***'+this.state.data.Bill)
              this.state.data.map((data2) => {
                return (
                  (this.state.cityHolder==='')?
                  <Row className="listBranch">
                    <Col sm="12" ><Link  to={'#/viewonmap/'+data2.Latitude+'/'+data2.Longitude+'/'+data2.Name}  onClick={()=>this.viewMap(data2.Latitude, data2.Longitude, data2.Name)} className="companyName btn btn-sm animated-button victoria-one">{data2.Name}</Link></Col>
                    <Col sm="12" className="addressCo">{data2.Address}</Col>
                    <br/>
                    <Col sm="4" className="liIcon"><FontAwesomeIcon icon={faFax} className="fontinBranch" /><span>{data2.Fax}</span></Col>
                    <Col sm="4" className="liIcon"><FontAwesomeIcon icon={faPhone} className="fontinBranch" /><span>{data2.Tel}</span></Col>
                    {data2.Latitude!==0 && data2.Longitude!==0 ?<Col sm="4" className="liIcon"><FontAwesomeIcon icon={faMapPin} className="fontinBranch" /><span className="dirLTR"> {((Math.round(data2.Distance * 1000) / 10)>1)? (Math.round(data2.Distance * 1000) / 10 )+"km":  (Math.round(data2.Distance * 1000000) / 10 )+"m"}  </span></Col>:''}
                    
                  </Row>
                  :
                  (libs.StringFunctions.KaafYe(data2.City).includes(this.state.cityHolder))?
                  <Row className="listBranch">
                    <Col sm="12" ><Link  to={'#/viewonmap/'+data2.Latitude+'/'+data2.Longitude+'/'+data2.Name}  onClick={()=>this.viewMap(data2.Latitude, data2.Longitude, data2.Name)} className="companyName btn btn-sm animated-button victoria-one">{data2.Name}</Link></Col>
                    <Col sm="12" className="addressCo">{data2.Address}</Col>
                    <br/>
                    <Col sm="4" className="liIcon"><FontAwesomeIcon icon={faFax} className="fontinBranch" /><span>{data2.Fax}</span></Col>
                    <Col sm="4" className="liIcon"><FontAwesomeIcon icon={faPhone} className="fontinBranch" /><span>{data2.Tel}</span></Col>
                    {data2.Latitude!==0 && data2.Longitude!==0 ?<Col sm="4" className="liIcon"><FontAwesomeIcon icon={faMapPin} className="fontinBranch" /><span className="dirLTR">{((Math.round(data2.Distance * 1000) / 10)>1)? (Math.round(data2.Distance * 1000) / 10 )+"km":  (Math.round(data2.Distance * 1000000) / 10 )+"m"} </span></Col>:''}
                  </Row>
                  :
                  ''
                )
              })
            }


          </Container>) : (<ui.Preloader />)
        }
      </div>
    );
  }
}
export default ListViewBranch;


// WEBPACK FOOTER //
// ./src/components/ListView/ListViewBranch.js